import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Metamodel } from '../base/model';

import { TabularTypeDataset } from './tabular-type.dataset';
import { IModel } from '../base/annotation';
import { format } from 'app/shared/utils/string.util';
import { DynamicsCrmLinkedService } from 'app/model/linkedservice/dynamics-crm.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.dynamicsCRM.datasetType,
    display: [format(stringResources.ModelName_DatasetTemplate, stringResources.DynamicsCRMEntity_DisplayText),
    format(stringResources.ModelName_DatasetsTemplate, stringResources.DynamicsCRMEntity_DisplayText)],
    constraints: {
        linkedService: {
            model: DynamicsCrmLinkedService.MODEL // Linked service redefined
        }
    }
})
export class DynamicsCrmEntityDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
